<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <urbanism-document-add
          @handleAddDocument="handleAddDocument"
          @handleEditDocument="handleEditDocument"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import TitleBar from "../components/TitleBar.vue";
import CardComponent from "@/components/CardComponent";
import { pathOr } from "ramda";
import UrbanismDocumentAdd from "../components/urbanism/urbanismdocument-add.vue";
import Urbanism from "../services/urbanism.service";
import { notify } from "@/helpers/notify";

export default {
  components: { TitleBar, UrbanismDocumentAdd, CardComponent },
  name: "UrbanismDocument",
  data() {
    return {
      document: {},
      documentId: 0,
      editMode: false,
    };
  },
  computed: {
    titleStack() {
      const parent = { label: "Registru Urbanism", to: "/Urbanism" };
      if (this.editMode) {
        return [parent, "Editare document"];
      } else {
        return [parent, "Adaugare document"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare document";
      } else {
        return "Adaugare document";
      }
    },
  },
  methods: {
    async handleAddDocument(document) {
      try {
        const { addDocument } = Urbanism;
        const response = await addDocument(document);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Inregistrarea a fost adaugata.");
          this.$router.push({ path: `/Urbanism` });
        } else {
          notify.error(this, "Eroare la adaugarea inregistrarii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async handleEditDocument(document) {
      try {
        const { editDocument } = Urbanism;
        const response = await editDocument(document);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Inregistrarea a fost modificata.");
        } else {
          notify.error(this, "Eroare la editarea inregistrarii.");
        }
        this.$router.push({ path: "/Urbanism" });
      } catch (error) {
        notify.error(this, "Eroare la editarea inregistrarii.");
      }
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    if (id) {
      this.editMode = true;
    }
    this.documentId = id;
  },
};
</script>

<style></style>
